export default __webpack_public_path__ + "static/Products_Placeholder_1.0@2x-4f1475d1083eb2b110680ec47d1136c4.jpg";